import { render, staticRenderFns } from "./ToggleOverviewMode.vue?vue&type=template&id=21005d95&"
import script from "./ToggleOverviewMode.vue?vue&type=script&lang=ts&"
export * from "./ToggleOverviewMode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports